import { render, staticRenderFns } from "./BranchHumanResourcesAssignCreate.vue?vue&type=template&id=a3b37b32&"
import script from "./BranchHumanResourcesAssignCreate.vue?vue&type=script&lang=js&"
export * from "./BranchHumanResourcesAssignCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports